var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLogin)?_c('v-footer',{staticClass:"footer-title",attrs:{"height":"50","dark":"","app":""}},[_c('v-card-text',{staticClass:"text-center"},[_vm._v(" 産廃コンテナBee システム © 2022 SMS Corp. ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }